<template>
  <section class="pfp">
    <!--    <div class="bg-black w-full pb-0 pt-100 lg:py-0 lg:mt-200 px-16 pb-30 lg:px-0 h-screen lg:h-130-screen">-->
    <div class="bg-black w-full pb-0 pt-100 lg:py-0 lg:mt-200 px-16 pb-30 lg:px-0">
      <div class="blex bg-black w-full">
        <div class="text-white font-bold text-2xl lg:text-6xl blex bottom-gradient pb-12">
          NFT COLLECTION
        </div>
        <div class="text-white font-bold text-2xl lg:text-5xl blex  w-full pt-8 lg:pt-30">
          06
        </div>
      </div>
      <div class="blex">
        <div class="text-2xl lg:text-4xl font-semiBold text-white w-full text-center pt-40 lg:pt-120">
          PFP
        </div>
        <div class="text-white font-medium leading-xs text-center text-2xs lg:text-base py-40 w-full lg:w-1/2"
             data-scroll
             data-scroll-speed="1">
          <div>
            {{ $t('pfp.1') }}
            {{ $t('pfp.2') }}
            <!--            <br class="block lg:hidden">-->
          </div>
          <div class="py-30 lg:py-0">
            {{ $t('pfp.3') }}
            {{ $t('pfp.4') }}
          </div>
          {{ $t('pfp.5') }}
        </div>
      </div>

      <!--  pfp image    -->
      <div class="flex flex-no-wrap image-container">
        <div class="blex flex-no-wrap">
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp43.png') : require('@/assets/images/pages/main/pfp/mPfp43.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp44.png') : require('@/assets/images/pages/main/pfp/mPfp44.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp45.png') : require('@/assets/images/pages/main/pfp/mPfp45.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp46.png') : require('@/assets/images/pages/main/pfp/mPfp46.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp47.png') : require('@/assets/images/pages/main/pfp/mPfp47.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp48.png') : require('@/assets/images/pages/main/pfp/mPfp48.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp49.png') : require('@/assets/images/pages/main/pfp/mPfp49.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp50.png') : require('@/assets/images/pages/main/pfp/mPfp50.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp51.png') : require('@/assets/images/pages/main/pfp/mPfp51.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp52.png') : require('@/assets/images/pages/main/pfp/mPfp52.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp53.png') : require('@/assets/images/pages/main/pfp/mPfp53.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp54.png') : require('@/assets/images/pages/main/pfp/mPfp54.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp55.png') : require('@/assets/images/pages/main/pfp/mPfp55.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp56.png') : require('@/assets/images/pages/main/pfp/mPfp56.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp57.png') : require('@/assets/images/pages/main/pfp/mPfp57.png')"
                class="pfp">
          </div>
        </div>
        <div class="blex flex-no-wrap">
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp43.png') : require('@/assets/images/pages/main/pfp/mPfp43.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp44.png') : require('@/assets/images/pages/main/pfp/mPfp44.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp45.png') : require('@/assets/images/pages/main/pfp/mPfp45.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp46.png') : require('@/assets/images/pages/main/pfp/mPfp46.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp47.png') : require('@/assets/images/pages/main/pfp/mPfp47.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp48.png') : require('@/assets/images/pages/main/pfp/mPfp48.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp49.png') : require('@/assets/images/pages/main/pfp/mPfp49.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp50.png') : require('@/assets/images/pages/main/pfp/mPfp50.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp51.png') : require('@/assets/images/pages/main/pfp/mPfp51.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp52.png') : require('@/assets/images/pages/main/pfp/mPfp52.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp53.png') : require('@/assets/images/pages/main/pfp/mPfp53.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp54.png') : require('@/assets/images/pages/main/pfp/mPfp54.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp55.png') : require('@/assets/images/pages/main/pfp/mPfp55.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp56.png') : require('@/assets/images/pages/main/pfp/mPfp56.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp57.png') : require('@/assets/images/pages/main/pfp/mPfp57.png')"
                class="pfp">
          </div>
        </div>
        <div class="blex flex-no-wrap">
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp43.png') : require('@/assets/images/pages/main/pfp/mPfp43.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp44.png') : require('@/assets/images/pages/main/pfp/mPfp44.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp45.png') : require('@/assets/images/pages/main/pfp/mPfp45.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp46.png') : require('@/assets/images/pages/main/pfp/mPfp46.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp47.png') : require('@/assets/images/pages/main/pfp/mPfp47.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp48.png') : require('@/assets/images/pages/main/pfp/mPfp48.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp49.png') : require('@/assets/images/pages/main/pfp/mPfp49.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp50.png') : require('@/assets/images/pages/main/pfp/mPfp50.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp51.png') : require('@/assets/images/pages/main/pfp/mPfp51.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp52.png') : require('@/assets/images/pages/main/pfp/mPfp52.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp53.png') : require('@/assets/images/pages/main/pfp/mPfp53.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp54.png') : require('@/assets/images/pages/main/pfp/mPfp54.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp55.png') : require('@/assets/images/pages/main/pfp/mPfp55.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp56.png') : require('@/assets/images/pages/main/pfp/mPfp56.png')"
                class="pfp">
          </div>
          <div class="blex">
            <img
                :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/pfp/pfp57.png') : require('@/assets/images/pages/main/pfp/mPfp57.png')"
                class="pfp">
          </div>
        </div>
      </div>
    </div>
  </section>

</template>

<script>
export default {
  name: 'Pfp',
  methods: {}
}
</script>

<style scoped lang="scss">
section::v-deep {

  .image-container {
    animation: slide 12s linear infinite;
    transform: translate3d(0, 0, 0);

    &:hover {
      animation-play-state: paused;
    }

    .pfp {
      max-width: 270px;
      margin: 0 3px;
      transition: all .3s;

      &:hover {
        transform: scale(1.2);
        transition: all .3s;
      }
    }

    @media screen and (max-width: 1024px) {
      .pfp {
        width: 90px;
        margin: 0 1px;
      }
    }

  }

  @keyframes slide {

    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-100%);
    }
  }

  //.image-container2 {
  //
  //  animation: slide2 14s linear infinite;
  //  transform: translate3d(0, 0, 0);
  //  @media screen and (max-width: 1024px) {
  //    .pfp {
  //      width: 90px;
  //    }
  //  }
  //}
  //
  //@keyframes slide2 {
  //
  //  0% {
  //    transform: translate3d(0vw, 0, 0);
  //  }
  //  100% {
  //    //transform: translate3d(99.3vw, 0, 0);
  //    transform: translate3d(99.4vw, 0, 0);
  //  }
  //}

}

</style>
